module.exports = __webpack_public_path__ + "img/facebook.1.e9abc0bc.svg";